export class PropertyViewCard {
    constructor (
        public baths: number = null,
        public beds: number = null,
        public city: string = '',
        public rent: string = null,
        public min_rent: string = null,
        public max_rent: string = null,
        public rentValue: number = null,
        public special: string = '',
        public sqft: string = null,
        public sqftValue: number = null,
        public status: string = '',
        public street: string = '',
        public thumb: string = '',
        public title: string = '',
        public unit_code: string = '',
        public zip: string = '',
        public post_status: string = '',
        public region: string = '',
        public link: string = ''
    ) { }
}